// extracted by mini-css-extract-plugin
module.exports = {"root":"post-section_root__1JUQF"};